import { Spinner } from "@chakra-ui/react";


export default function DefaultSpinner() {
	return (
		<Spinner
			thickness="2px"
			speed="0.65s"
			emptyColor="gray.200"
			color="brand.500"
			boxSize="1.2em"
			/>
	)
}